module.exports = __webpack_public_path__ + "img/earth-texture.94a2e34a.jpg";